import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import Box from '@uikit/components//Box/Box';
import Button from '@uikit/components/Button/Button';
import { ClickableAction } from '@uikit/components/Clickable/consts';
import { ButtonSize } from '../Button/consts';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import { CLASSIC_BREAKPOINT_ASPECT_RATIO_CONFIGS } from '../LegacyPicture/consts';
import styles from './RegioChecklist.module.scss';
import type { RegioChecklistProps } from './interfaces';

const RegioChecklist = ({
  image,
  mainTitle,
  mainDescription,
  boxTitle,
  boxDescription,
  listItems,
  link,
  linkText,
}: RegioChecklistProps) => {
  const isMobile = useIsMobile(992);

  return (
    <div className={styles.base}>
      <div className={styles.imageWrapper}>
        <LegacyPicture
          fitCover
          asset={image}
          breakpointAspectRatioConfigs={CLASSIC_BREAKPOINT_ASPECT_RATIO_CONFIGS}
        />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{mainTitle}</h3>
        <p className={styles.descriptionTop}>{mainDescription}</p>
        <Box className={styles.wrapper}>
          <ul className={styles.list}>
            {listItems.map((item) => (
              <li className={styles.listItem} key={item}>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <h3 className={styles.title}>{boxTitle}</h3>
          <p className={styles.descriptionBottom}>{boxDescription}</p>
          <Button
            actionType={ClickableAction.Linkextern}
            linkextern={link}
            className={styles.button}
            size={isMobile ? ButtonSize.Medium : ButtonSize.Large}
          >
            {linkText}
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default RegioChecklist;
